import { BIG_FILE_DURATION_MS, BIG_FILE_SIZE, MEDIUM_FILE_DURATION_MS, MEDIUM_FILE_SIZE, SMALL_FILE_DURATION_MS } from './constants';

/**
 * Determine duration based on file size
 */
export const getDurationByFileSize = (size: number): number => {
  if (size >= BIG_FILE_SIZE) return BIG_FILE_DURATION_MS;
  if (size >= MEDIUM_FILE_SIZE) return MEDIUM_FILE_DURATION_MS;
  return SMALL_FILE_DURATION_MS;
};
